
import ButtonVue from "@/components/ui/Button.vue";
import CheckboxVue from "@/components/ui/Checkbox.vue";
import RangeVue from "@/components/ui/Range.vue";
import { namespaceName } from "@/store/createStore";
import { customizableExerciseStateProps } from "@/store/modules/exercise";
import {
  ExerciseActions,
  ExerciseModuleMap,
  UpdatePreferencesPayload,
} from "@/store/modules/exercise/types";
import { StoreState } from "@/store/types";
import { defineComponent } from "vue";
import { mapState } from "vuex";

type ComputedTypes = ExerciseModuleMap<typeof customizableExerciseStateProps>;

export default defineComponent({
  name: "Preferences",
  components: {
    appCheckbox: CheckboxVue,
    appRange: RangeVue,
    appButton: ButtonVue,
  },

  computed: {
    ...(mapState<StoreState>(
      "exercise",
      customizableExerciseStateProps
    ) as ComputedTypes),
  },

  methods: {
    changeHandler(
      propName: UpdatePreferencesPayload["propName"],
      value: UpdatePreferencesPayload["value"]
    ) {
      this.$store.dispatch(
        namespaceName("exercise", ExerciseActions.UpdatePreferences),
        {
          propName: propName,
          value: value,
        } as UpdatePreferencesPayload
      );
    },

    restoreDefault() {
      this.$store.dispatch(
        namespaceName("exercise", ExerciseActions.RestoreDefault)
      );
    },
  },
});
